<nav class="myce-header-nav" aria-label="Primary navigation">
  <ul class="myce-header-nav__list" role="list">

    <li *ngFor="let item of navItems; let i = index; trackBy: trackByLabel" class="myce-header-nav__item"
      [class.myce-header-nav__item--has-dropdown]="item.hasDropdown">

      <!-- Plain link (no dropdown) -->
      <a *ngIf="!item.hasDropdown && item.routeKey" [routerLink]="('/' + item.routeKey) | langLink"
        class="myce-header-nav__link" [routerLinkActive]="'myce-header-nav__link--active'"
        [ariaCurrentWhenActive]="'page'">
        <span class="english">{{ item.labelEn }}</span>
        <span class="spanish hidden">{{ item.labelEs }}</span>
      </a>

      <!-- Dropdown trigger -->
      <button *ngIf="item.hasDropdown" #navTrigger type="button"
        class="myce-header-nav__link myce-header-nav__link--dropdown-trigger"
        [class.myce-header-nav__link--active]="isDropdownActive(item)" [attr.aria-expanded]="isDropdownOpen(i)"
        aria-haspopup="menu" (click)="toggleDropdown(i)" (keydown)="onNavKeydown($event, i)">
        <span class="english">{{ item.labelEn }}</span>
        <span class="spanish hidden">{{ item.labelEs }}</span>
        <svg class="myce-header-nav__caret" [class.myce-header-nav__caret--open]="isDropdownOpen(i)" aria-hidden="true"
          focusable="false" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>

      <!-- Dropdown panel -->
      <xbh-nav-dropdown *ngIf="item.hasDropdown && isDropdownOpen(i)" [items]="item.dropdownItems || []"
        (closed)="closeSilently()" (closedByKey)="closeDropdown()">
      </xbh-nav-dropdown>

    </li>
  </ul>
</nav>